import { render, staticRenderFns } from "./zjzxxq.vue?vue&type=template&id=68808d66&scoped=true&"
import script from "./zjzxxq.vue?vue&type=script&lang=js&"
export * from "./zjzxxq.vue?vue&type=script&lang=js&"
import style0 from "./zjzxxq.vue?vue&type=style&index=0&id=68808d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68808d66",
  null
  
)

export default component.exports